import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import UserRating from 'common/components/UserRating';
import Avatar from 'common/components/user/Avatar';
import { path, getReadMorePath } from 'common/tools/network/routing';
import trans from 'common/tools/translations/trans';

import onlyIfHasSocial from 'website/components/HoC/onlyIfHasSocial';

import styles from './styles.module.scss';

const FolloweeRatingDetail = props => {
  const {
    user: { mainAvatar, legacyId, nickname },
    opinion,
    entityId,
    entityType
  } = props;
  let ratingLabel;
  let reviewLink = null;
  const readMorePath = opinion.hasReview ? getReadMorePath(entityType) : null;

  if (readMorePath) {
    ratingLabel = (
      <>
        <span className={styles.followeeName}>{nickname}</span>{' '}
        {trans('rating.friends.has-review')}
      </>
    );
    const reviewUrl = path(readMorePath, {
      entity: entityId,
      user: legacyId.toUpperCase()
    });
    reviewLink = (
      <a className={styles.followeeDetailsBlock} href={reviewUrl}>
        {trans('rating.friends.read-review')}
      </a>
    );
  } else {
    ratingLabel = (
      <>
        <span className={styles.followeeName}>{nickname}</span>{' '}
        {trans(`rating.friends.${entityType.toLowerCase()}.has-note`)}
      </>
    );
  }
  const profileUrl = path('userprofile_index', {
    user: legacyId.toLowerCase()
  });

  return (
    <figure className={classNames(styles.followeeDetails, 'cf', 'hred')}>
      <a className={styles.followeeDetailsThumb} href={profileUrl}>
        <Avatar
          alt={nickname}
          className={styles.followeeAvatar}
          src={mainAvatar}
        />
      </a>
      <figcaption>
        {ratingLabel}
        <div>
          <UserRating value={opinion.rating} readOnly />
        </div>
        {reviewLink}
      </figcaption>
    </figure>
  );
};

FolloweeRatingDetail.propTypes = {
  opinion: PropTypes.shape({
    rating: PropTypes.number,
    hasReview: PropTypes.bool
  }).isRequired,
  user: PropTypes.shape({
    legacyId: PropTypes.string.isRequired,
    mainAvatar: PropTypes.string,
    nickname: PropTypes.string
  }).isRequired,
  entityId: PropTypes.number.isRequired,
  entityType: PropTypes.string.isRequired
};

export default onlyIfHasSocial(FolloweeRatingDetail);
